import React, { useCallback } from "react";
import classnames from "classnames";
import PropTypes from "prop-types";

export const ListItem = ({ children, onClick, className }) => {
  const handleClick = useCallback(
    (event) => {
      if (!event.defaultPrevented && typeof onClick === "function") {
        onClick(event);
      }
    },
    [onClick]
  );

  return (
    <li
      className={classnames("chat-list-item tw-flex tw-items-center tw-cursor-pointer tw-p-2 tw-rounded-lg", className)}
      onClick={handleClick}
    >
      {children}
    </li>
  );
};

ListItem.propTypes = {
  children: PropTypes.node,
  onClick: PropTypes.func,
  className: PropTypes.string,
};
